import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MarketProfileService } from './market-profile.service';
import { MarketProfile } from './market-profile.model';


export class MarketProfileDataSource implements DataSource<MarketProfile> {

  private dataSubject = new BehaviorSubject<MarketProfile[]>([]);
  private dataLengthSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public data = this.dataSubject.asObservable();
  public dataLength = this.dataLengthSubject.asObservable();
  public loading = this.loadingSubject.asObservable();

  constructor(private marketProfileService: MarketProfileService) {}

  connect(collectionViewer: CollectionViewer): Observable<MarketProfile[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadMarketProfiles(
    pageIndex: number,
    pageSize: number,
    sortBy: string = 'createdAt',
    sortDirection: string = 'asc',
    filter: string = '',
  ) {

    this.loadingSubject.next(true);

    this.marketProfileService
      .findPaginated(
        pageIndex,
        pageSize,
        sortBy,
        sortDirection,
        filter
      )
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(data => {
        this.dataSubject.next(data._embedded.market_profile);
        this.dataLengthSubject.next(data.total_items);
      });
  }
}
